import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

Vue.use(Vuex);//使用vuex


const state ={
    count: 1,
    themeValue: window.localStorage.getItem('themeValue'),
    token: window.localStorage.getItem('token'),
    menus: [],
    userInfo: {},
}
//创建vuex实例
const store = new Vuex.Store({ actions, getters, mutations, state });

export default store;